enum FileType {
  Carrier = 'carrier',
  Client = 'client',
  Personal = 'personal',
}

export default FileType;
